import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import heroBanner from '../assets/images/hero-banner.png';
import whoweare from '../assets/images/who-we-are.png';
import innovation from '../assets/images/Innovation.png';
import integrity from '../assets/images/Integrity.png';
import collaboration from '../assets/images/Collaboration.png';
import excellenace from '../assets/images/Excellence.png';
import creativity from '../assets/images/creativity-thumbnail.png';
import empowering from '../assets/images/empowering.png';
import integrationjourney from '../assets/images/integration-journey.png';
import connectionbanner from '../assets/images/connection-banner.png';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/bubbles.css';
import '../styles/style.css';
import { Link } from 'react-router-dom';



const About = () => {
 
 
  return (
  
      <>
    {/* <!-- preloader --> */}
   
    {/* <!-- preloader end  --> */}

     {/* <!-- Mouse Cursor Start -->   */}
     <div className="mouse-cursor cursor-outer"></div>
     <div className="mouse-cursor cursor-inner"></div>


    <header className="top-header inner-banner" style={{background: `url(${heroBanner}) no-repeat top center`}}>
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <Navbar/>
      <section className="banner-caption flex-center">
        <div className="caption-header text-white">
          <div className="container text-center">
            <h1 className="caption-title"> The Power Behind Seamless Technology </h1>
            <p className="col-lg-10 mx-auto caption-sub-title pt-3 text-white"> Connecting Systems, Empowering Growth: Your Trusted Partner in Technology </p>
          </div>
        </div>
      </section>
    </header>
    <section className="home-about light-gradient-bg py-5">
      <div className="container">
        <div className="row py-5 align-items-center">
          <div className="col-lg-8">
            <div className="column-left">
              <div className="title mb-5">
                <h1 className="section-title">Who We Are</h1>
              </div>
              <div className="column-left-content home-about-content">
                <p className="mb-0"> At Entegation Technologies, we're more than just a technology company—we're a collective of passionate innovators, thinkers, and problem solvers. Our journey is rooted in the belief that technology should empower businesses to achieve their full potential. We understand that in a rapidly evolving digital landscape, staying ahead requires not only adapting to change but leading it. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-end">
                <div className="thumbnail-block">
                  <div className="card-image">
                    <img src={whoweare} alt="About-image" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="approach light-bg-column py-5">
      <div className="container">
        <div className="row py-5 gx-5">
          <div className="col-12 text-center">
            <div className="title mb-5">
              <h1 className="section-title mb-4"> Our Core Values: What Drives Us </h1>
              <p className="section-title-sub mb-5"> Our work is driven by a set of core values that shape every decision we make and every project we undertake: </p>
            </div>
          </div>
          <div className="col-lg-6 border-right-full border-bottom-line-left pb-5">
            <div className="list-approach text-center">
              <div className="icon mb-5">
                <img src={innovation} alt="innovation-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Innovation</h1>
              </div>
              <div className="column-content ps-lg-5 pe-lg-5 pb-3">
                <p className="ps-lg-5 pe-lg-5"> We are relentless in our pursuit of innovative solutions. Whether it’s integrating legacy systems or pioneering new technology platforms, we challenge the status quo to deliver exceptional results. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 border-bottom-line-right">
            <div className="list-approach text-center">
              <div className="icon mb-5">
                <img src={integrity} alt="Integrity-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Integrity</h1>
              </div>
              <div className="column-content ps-lg-5 pe-lg-5">
                <p className="ps-lg-5 pe-lg-5"> Trust is the foundation of our relationships. We hold ourselves to the highest ethical standards, ensuring transparency, honesty, and accountability in all our dealings. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 border-right-full">
            <div className="list-approach text-center pt-5">
              <div className="icon mb-5">
                <img src={collaboration} alt="Collaboration-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Collaboration</h1>
              </div>
              <div className="column-content ps-lg-5 pe-lg-5">
                <p className="ps-lg-5 pe-lg-5"> We believe in the power of teamwork. Our collaborative approach ensures that every project benefits from diverse perspectives, collective expertise, and a shared commitment to success. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="list-approach text-center pt-5">
              <div className="icon mb-5">
                <img src={excellenace} alt="Excellence-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Excellence</h1>
              </div>
              <div className="column-content ps-lg-5 pe-lg-5">
                <p className="ps-lg-5 pe-lg-5"> Excellence isn’t just a goal; it’s our standard. From the initial consultation to the final implementation, we strive for nothing less than the best. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="two-column-thumbnail py-5">
      <div className="container">
        <div className="row d-flex align-items-center py-5">
          <div className="col-lg-4">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-start">
                <div className="thumbnail-block">
                  <div className="card-image">
                    <img src={creativity} alt="About-image" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 ps-lg-5">
            <div className="side-content-block">
              <div className="title">
                <h1 className="section-title mb-4"> A Hub of Creativity and Innovation </h1>
                <p className="section-title-sub"> The culture at Entegation Technologies is one that encourages creativity, fosters innovation, and rewards curiosity. We believe that great ideas can come from anywhere, and we create an environment where every voice is heard, and every team member is empowered to contribute. Our collaborative workspace is designed to inspire, with an emphasis on continuous learning, experimentation, and personal growth. </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex align-items-center flex-row-reverse py-5">
          <div className="col-lg-4">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-end">
                <div className="thumbnail-block">
                  <div className="card-image">
                    <img src={empowering} alt="About-image" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 pe-lg-5">
            <div className="side-content-block">
              <div className="title">
                <h1 className="section-title mb-4"> Our Commitment: <br />Empowering Your Business </h1>
                <p className="section-title-sub"> We see ourselves as partners in your success. Our commitment goes beyond delivering solutions—we aim to empower your business with the tools, insights, and support needed to thrive in a complex technological landscape. We take the time to understand your unique challenges and tailor our services to meet your specific needs, ensuring that our solutions are not just effective but transformative. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="center-caption py-5">
      <div className="container">
        <div className="row py-5">
          <div className="col-12">
            <div className="text-white py-5">
              <div className="title pb-5">
                <h1 className="section-title text-white"> Our Vision for the Future </h1>
              </div>
              <p className="text-white"> As we look to the future, our vision is clear: to be at the forefront of technological innovation, leading the way in enterprise technology integration. We are committed to continuously expanding our expertise, exploring new technologies, and developing solutions that not only meet the needs of today but also anticipate the demands of tomorrow. <br />
                <br /> We believe that the future of business is interconnected, where technology systems work seamlessly together to create unprecedented opportunities for growth and innovation. With Entegation Technologies as your partner, you can be confident that you are equipped to navigate the complexities of this new digital era.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="two-column-thumbnail py-5">
      <div className="container">
        <div className="row d-flex align-items-center pt-5">
          <div className="col-lg-4">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-start">
                <div className="thumbnail-block">
                  <div className="card-image">
                    <img src={integrationjourney} alt="About-image" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 ps-lg-5">
            <div className="side-content-block">
              <div className="title">
                <h1 className="section-title mb-4"> Join the Entegation Journey </h1>
                <p className="section-title-sub"> Our story is still being written, and we invite you to be a part of it. Whether you're a potential client, a future team member, or a partner, we believe in building strong, lasting relationships that drive mutual success. <br />
                  <br /> At Entegation Technologies, we’re not just building solutions—we’re building the future. And we’re excited to have you on this journey with us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bottom-bg py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="dark-bg-block">
              <div className="tech-integration d-flex align-items-center">
                <div className="col-lg-4">
                  <div className="contact-info-block text-white">
                    <p className="py-4"> Join our team of talented innovators and be a part of shaping the future of technology. Explore our career opportunities here. </p>
                    <Link to="/contact-us" className="btn btn-outline-white">Contact Us Now</Link>
                  </div>
                </div>
                <div className="col">
                  <div className="connection-banner d-flex justify-content-end">
                    <img src={connectionbanner} alt="Integration banner" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- footer --> */}
   <Footer/>
    <div className="progress-wrap">
      <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>
   
    <Helmet>
       <title>Entegation Technologies | About</title>
        <script src="/assets/js/script.js"></script>
    </Helmet>
      </>
   

  )

}

export default About